import React from "react";
import Box from "@mui/material/Box";
import { Link } from "react-router";
import { SnetSvgLogo } from "shared/dist/components";
import classes from "./RegistrationHeader.module.css";

const RegistrationHeader = ({ headerTitle, headerLinkText, headerLinkTo }) => {
    return (
        <Box className={classes.registrationHeaderContainer}>
            <Box className={classes.logoContainer}>
                <h1>
                    <Link to="">
                        <SnetSvgLogo />
                    </Link>
                </h1>
            </Box>
            {headerLinkTo && (
                <Box className={classes.headerLink}>
                    <span>{headerTitle} &nbsp;</span>
                    <Link to={headerLinkTo}>{headerLinkText}</Link>
                </Box>
            )}
        </Box>
    );
};

export default RegistrationHeader;
